/* tslint:disable */
/* eslint-disable */
/**
 * Muze REST API
 * API Data backend for Muze
 *
 * The version of the OpenAPI document: 1.6.0
 * Contact: dash@muze.nyc
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CustomTokenObtainPair,
    CustomTokenObtainPairFromJSON,
    CustomTokenObtainPairToJSON,
    Login,
    LoginFromJSON,
    LoginToJSON,
    PasswordReset,
    PasswordResetFromJSON,
    PasswordResetToJSON,
    PasswordResetConfirm,
    PasswordResetConfirmFromJSON,
    PasswordResetConfirmToJSON,
    TokenRefresh,
    TokenRefreshFromJSON,
    TokenRefreshToJSON,
} from '../models';

export interface AuthLoginCreateRequest {
    login: Login;
}

export interface AuthPasswordResetConfirmCreateRequest {
    token: string;
    uid: number;
    passwordResetConfirm: PasswordResetConfirm;
}

export interface AuthPasswordResetCreateRequest {
    passwordReset?: PasswordReset;
}

export interface AuthTokenCreateRequest {
    customTokenObtainPair: CustomTokenObtainPair;
}

export interface AuthTokenRefreshCreateRequest {
    tokenRefresh: TokenRefresh;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
     */
    async authLoginCreateRaw(requestParameters: AuthLoginCreateRequest): Promise<runtime.ApiResponse<Login>> {
        if (requestParameters.login === null || requestParameters.login === undefined) {
            throw new runtime.RequiredError('login','Required parameter requestParameters.login was null or undefined when calling authLoginCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/login/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginToJSON(requestParameters.login),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginFromJSON(jsonValue));
    }

    /**
     * Check the credentials and return the REST Token if the credentials are valid and authenticated. Calls Django Auth login method to register User ID in Django session framework  Accept the following POST parameters: username, password Return the REST Framework Token Object\'s key.
     */
    async authLoginCreate(requestParameters: AuthLoginCreateRequest): Promise<Login> {
        const response = await this.authLoginCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     */
    async authLogoutCreateRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/logout/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     */
    async authLogoutCreate(): Promise<void> {
        await this.authLogoutCreateRaw();
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     */
    async authLogoutRetrieveRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/logout/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Calls Django logout method and delete the Token object assigned to the current User object.  Accepts/Returns nothing.
     */
    async authLogoutRetrieve(): Promise<void> {
        await this.authLogoutRetrieveRaw();
    }

    /**
     * Redirects to muzeapp:/path/to/api/request/ MUST BE INHERITED FIRST!
     */
    async authPasswordResetConfirmCreateRaw(requestParameters: AuthPasswordResetConfirmCreateRequest): Promise<runtime.ApiResponse<PasswordResetConfirm>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling authPasswordResetConfirmCreate.');
        }

        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling authPasswordResetConfirmCreate.');
        }

        if (requestParameters.passwordResetConfirm === null || requestParameters.passwordResetConfirm === undefined) {
            throw new runtime.RequiredError('passwordResetConfirm','Required parameter requestParameters.passwordResetConfirm was null or undefined when calling authPasswordResetConfirmCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/password/reset/confirm/{uid}/{token}/`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))).replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetConfirmToJSON(requestParameters.passwordResetConfirm),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetConfirmFromJSON(jsonValue));
    }

    /**
     * Redirects to muzeapp:/path/to/api/request/ MUST BE INHERITED FIRST!
     */
    async authPasswordResetConfirmCreate(requestParameters: AuthPasswordResetConfirmCreateRequest): Promise<PasswordResetConfirm> {
        const response = await this.authPasswordResetConfirmCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async authPasswordResetCreateRaw(requestParameters: AuthPasswordResetCreateRequest): Promise<runtime.ApiResponse<PasswordReset>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/password/reset/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetToJSON(requestParameters.passwordReset),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetFromJSON(jsonValue));
    }

    /**
     */
    async authPasswordResetCreate(requestParameters: AuthPasswordResetCreateRequest): Promise<PasswordReset> {
        const response = await this.authPasswordResetCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */
    async authTokenCreateRaw(requestParameters: AuthTokenCreateRequest): Promise<runtime.ApiResponse<CustomTokenObtainPair>> {
        if (requestParameters.customTokenObtainPair === null || requestParameters.customTokenObtainPair === undefined) {
            throw new runtime.RequiredError('customTokenObtainPair','Required parameter requestParameters.customTokenObtainPair was null or undefined when calling authTokenCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/token/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomTokenObtainPairToJSON(requestParameters.customTokenObtainPair),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomTokenObtainPairFromJSON(jsonValue));
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     */
    async authTokenCreate(requestParameters: AuthTokenCreateRequest): Promise<CustomTokenObtainPair> {
        const response = await this.authTokenCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async authTokenRefreshCreateRaw(requestParameters: AuthTokenRefreshCreateRequest): Promise<runtime.ApiResponse<TokenRefresh>> {
        if (requestParameters.tokenRefresh === null || requestParameters.tokenRefresh === undefined) {
            throw new runtime.RequiredError('tokenRefresh','Required parameter requestParameters.tokenRefresh was null or undefined when calling authTokenRefreshCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/token/refresh/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TokenRefreshToJSON(requestParameters.tokenRefresh),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenRefreshFromJSON(jsonValue));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     */
    async authTokenRefreshCreate(requestParameters: AuthTokenRefreshCreateRequest): Promise<TokenRefresh> {
        const response = await this.authTokenRefreshCreateRaw(requestParameters);
        return await response.value();
    }

}
